import _ from 'lodash';

function ProductBubbles(elRoot) {
  this.elems = {};
  this.elems.root = $(elRoot);
  this.elems.bubbles = this.elems.root.find('[data-bubble]');
  this.elems.targets = this.elems.root.find('[data-bubble-target]');
  this.elems.selector = this.elems.root.find('[data-bubble-selector]');
  this.elems.zoomer = this.elems.root.find('[data-inner-zoom]');
  
  this.currentBubble = null;

  this.bubbles = this.getBubbles();
  this.targets = this.getTargets();

  this.makeSelector();
  this.bindBubbles();

  $(this.elems.bubbles[0]).click();
}

ProductBubbles.prototype.getBubbles = function() {
  let bubbles = [];
  this.elems.bubbles.each(function() {
    let el = $(this);
    let bubData = el.data('bubble').split('|');
    bubbles.push({
      targetId: bubData[0],
      image: bubData[1],
      elem: el,
    });
  });
  return bubbles;
}

ProductBubbles.prototype.getTargets = function() {
  let targets = {};
  this.elems.targets.each(function() {
    let el = $(this);
    let targetId = el.data('bubble-target');
    targets[targetId] = el;
  });
  return targets;
}

ProductBubbles.prototype.bindBubbles = function() {
  for(let i=0; i<this.bubbles.length; i++) {
    let bub = this.bubbles[i];

    bub.elem.css({'background-image': "url('" + bub.image + "')"});

    bub.elem.on('click', () => {
      this.currentBubble = bub;
      this.elems.targets.hide();
      this.moveSelector();
      this.updateZoomer();
      if(this.targets[bub.targetId]) this.targets[bub.targetId].fadeIn();
    });
  }
}

ProductBubbles.prototype.makeSelector = function() {
  this.elems.selector.show();

  window.addEventListener('scroll', _.debounce(this.moveSelector.bind(this), 500));
}

ProductBubbles.prototype.moveSelector = function() {
  if(!this.currentBubble) return;
  let bubble = this.currentBubble;
  let scale = 1.2;
  let bubbleWidth = bubble.elem.width();
  let bubbleHeight = bubble.elem.height();
  let width = bubbleWidth * scale;
  let height = bubbleHeight * scale;
  let pos = bubble.elem.offset();
  let left = pos.left + ((bubbleWidth - width) / 2);
  let top = pos.top + ((bubbleHeight - height) / 2);
  this.elems.selector.css({
    width, height,
    left, top,
  });
}

ProductBubbles.prototype.updateZoomer = function() {
  if(!this.currentBubble) return;
  this.elems.zoomer.attr('data-inner-zoom', this.currentBubble.image);
  this.elems.zoomer.css({ 'background-image': "url('"+this.currentBubble.image+"')" });
}

export default function() {
  $('[data-product-bubbles]').each(function() {
    new ProductBubbles(this);
  });
};
